import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { getResultsRange } from '@/utils/shared/getResultsRange';

type ResultsCountProps = {
  pageNumber: number;
  pageSize: number;
  total: number;
  className?: string;
};

export default function ResultsCount({
  pageNumber,
  pageSize,
  total,
  className,
}: ResultsCountProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'common' });

  const { first, last } = getResultsRange({
    pageNumber,
    pageSize,
    totalCount: total,
  });

  return (
    <p className={twMerge('text-xs', className)}>
      {t('resultsRange', { first, last, total })}
    </p>
  );
}
